'use client';

import {cn} from '../../lib/utils';

import type {ComponentProps} from 'react';

function Label({className, ...props}: ComponentProps<'label'>) {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control -- primitive wrapper; htmlFor is passed via ...props by the consumer
    <label
      data-slot="label"
      className={cn(
        'text-fg-secondary flex items-start gap-0.5 select-none whitespace-nowrap text-sm leading-5 font-normal group-data-[disabled=true]:opacity-50 peer-disabled:opacity-50 group-data-[disabled=true]:pointer-events-none peer-disabled:cursor-not-allowed',
        className
      )}
      {...props}
    />
  );
}

export {Label};
